export default __webpack_public_path__ + "static/media/review.9e61db8a.svg";